import React from "react"
import { SensaiComponentTextSimpleText } from "../../../gql/generated/graphql"
import { Box } from "@mui/system"
import { Typography } from "@mui/material"
import ContentButton from "./ContentButton"
import MarkdownContent from "../../ui/MarkdownContent"

const SimpleText = ({ card }: { card: SensaiComponentTextSimpleText }) => {
  const { textStyle, title, description, link } = card
  const { textAlign, titleLevel } = textStyle ?? {
    textAlign: "left",
    titleLevel: "h3",
  }
  return (
    <Box
      data-aos="zoom-in"
      sx={{
        padding: "0",

        position: "relative",
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          marginTop: "auto",
          justifyContent:
            textAlign === "left"
              ? "start"
              : textAlign === "center"
              ? "center"
              : "end",
        }}
      >
        <Typography
          variant={titleLevel ?? "h3"}
          color={
            titleLevel === "h3" ? "var(--color-teal)" : "var(--color-dark)"
          }
          className={titleLevel === "h2" ? "gradientText" : ""}
          fontSize={
            titleLevel === "h2"
              ? "1.85rem"
              : titleLevel === "h3"
              ? "1.5rem"
              : "1.25rem"
          }
          lineHeight={
            titleLevel === "h2"
              ? "2.25rem"
              : titleLevel === "h3"
              ? "2.0rem"
              : "1.5rem"
          }
          fontWeight={
            titleLevel === "h2" ? 700 : titleLevel === "h3" ? 600 : 500
          }
          letterSpacing={
            titleLevel === "h2" ? "0.3px" : titleLevel === "h3" ? "0.3px" : 0
          }
        >
          {title}
        </Typography>
      </Box>

      {description && (
        <Box
          sx={{
            zIndex: "2",
            textAlign: textAlign,
            p: { textAlign: textAlign },
          }}
        >
          <MarkdownContent animate={false} content={description} />
        </Box>
      )}
      <Box sx={{}}>
        <ContentButton
          link={link ?? undefined}
          align={
            link?.type === "cardArrow"
              ? "end"
              : textAlign === "left"
              ? "start"
              : textAlign === "center"
              ? "center"
              : "end"
          }
          margin="1rem 0 0 0 "
        />
      </Box>
      <Box
        sx={{
          marginBottom: "auto",
        }}
      ></Box>
    </Box>
  )
}

export default SimpleText
